import StepDrawer from './StepDrawer';
import React, { useState } from "react";
import PrivacyControls from './PrivacyControls';
function SurgeryPrivacy({
    currentStep,
    totalSteps,
    formData,
    setFormData,
    onContinue,
    onCancel,
    onBack
}) {
    const selectPublic = () => {
        setFormData(prev => {
            return {
                ...prev,
                public: true
            }
        })
    }

    const selectPrivate = () => {
        setFormData(prev => {
            return {
                ...prev,
                public: false
            }
        })
    }

    return (
        <StepDrawer
            currentStep={currentStep}
            totalSteps={totalSteps}
            title="Visibility"
            onContinue={onContinue}
            onCancel={onCancel}
            onBack={onBack}
        >
            <PrivacyControls
                selectPrivate={selectPrivate}
                selectPublic={selectPublic}
                publicDescription="Allowing others to view your surgery can empower them to make more informed decisions about their own surgeon."
                privateDescription="Only you will be able to see this surgery."
                isPublic={formData.public}
            />
        </StepDrawer>
    )
}

export default SurgeryPrivacy;